export default __webpack_public_path__ + "static/softwaredevelopment-266ddd07a331344f2849bc6ee79289f3.png";